import type { TestimonialsPiece } from "@workspace/crystallize/generated/discovery/";
import { Quote } from "lucide-react";

export const Testimonials = ({
	title,
	text,
	testimonials,
}: TestimonialsPiece) => {
	return (
		<section className="container mx-auto space-y-8">
			<h2 className="text-center font-bold text-2xl">{title}</h2>
			<div className="mx-auto max-w-(--breakpoint-xl) columns-1 gap-8 md:columns-2 lg:columns-3">
				{testimonials?.map((testimonial) => (
					<>
						<div
							//TODO: Is this a good key?
							key={testimonial?.text}
							className="relative mb-8 break-inside-avoid rounded-xl bg-primary/5 p-6"
						>
							<div className="flex items-center justify-between">
								<div>
									<p className="font-semibold text-lg">{testimonial?.name}</p>
									<p className="text-gray-500 text-sm">
										{testimonial?.company}
									</p>
								</div>
								<div className="absolute top-4 right-4">
									<Quote className="h-6 w-6 text-gray-500" />
								</div>
							</div>
							<div
								className="prose-lg mt-5 text-gray-700"
								// biome-ignore lint/security/noDangerouslySetInnerHtml: <We are receiving html from Crystallize>
								dangerouslySetInnerHTML={{ __html: testimonial?.text ?? "" }}
							/>
						</div>
					</>
				))}
			</div>
		</section>
	);
};
